// src/pages/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import edfLogo from '../assets/edf-purview-logo-transparent.png';

// Hardcoded credentials
const VALID_CREDENTIALS = {
  // PRODUCTION - EDF Purview
  james: {
    username: 'James',
    password: 'james123',
    role: 'Administrator',
    department: 'IT Operations',
    environment: 'Production',
  },
  sarah: {
    username: 'Sarah',
    password: 'sarah123',
    role: 'Super Admin',
    department: 'Executive IT',
    environment: 'Production',
  },
  manager: {
    username: 'manager',
    password: 'manager123',
    role: 'Manager',
    department: 'Operations',
    environment: 'Production',
  },
  michael: {
    username: 'Michael',
    password: 'michael123',
    role: 'Director',
    department: 'Data Center Strategy',
    environment: 'Production',
  },
  engineer: {
    username: 'engineer',
    password: 'engineer123',
    role: 'Engineer',
    department: 'Engineering',
    environment: 'Production',
  },
  david: {
    username: 'David',
    password: 'david123',
    role: 'Developer',
    department: 'Software Development',
    environment: 'Production',
  },
  lisa: {
    username: 'Lisa',
    password: 'lisa123',
    role: 'Solutions Architect',
    department: 'Enterprise Architecture',
    environment: 'Production',
  },
  operator: {
    username: 'operator',
    password: 'operator123',
    role: 'Operator',
    department: 'Data Center',
    environment: 'Production',
  },
  user: {
    username: 'user',
    password: 'user123',
    role: 'User',
    department: 'Facilities',
    environment: 'Production',
  },
  emma: {
    username: 'Emma',
    password: 'emma123',
    role: 'Data Analyst',
    department: 'Business Intelligence',
    environment: 'Production',
  },

  // TESTING - Purview Projects
  john: {
    username: 'John',
    password: 'john123',
    role: 'Project Admin',
    department: 'Project Management',
    environment: 'Testing',
  },
  michelle: {
    username: 'Michelle',
    password: 'michelle123',
    role: 'Project Manager',
    department: 'PMO',
    environment: 'Testing',
  },
  alex: {
    username: 'Alex',
    password: 'alex123',
    role: 'Tech Lead',
    department: 'Project Engineering',
    environment: 'Testing',
  },
  laura: {
    username: 'Laura',
    password: 'laura123',
    role: 'Project Engineer',
    department: 'Engineering',
    environment: 'Testing',
  },
  chris: {
    username: 'Chris',
    password: 'chris123',
    role: 'Software Engineer',
    department: 'Development',
    environment: 'Testing',
  },
  amanda: {
    username: 'Amanda',
    password: 'amanda123',
    role: 'Project Coordinator',
    department: 'Operations',
    environment: 'Testing',
  },
  ryan: {
    username: 'Ryan',
    password: 'ryan123',
    role: 'Project Analyst',
    department: 'Project Delivery',
    environment: 'Testing',
  },
  karen: {
    username: 'Karen',
    password: 'karen123',
    role: 'Project Support',
    department: 'Support',
    environment: 'Testing',
  },
  paul: {
    username: 'Paul',
    password: 'paul123',
    role: 'QA Analyst',
    department: 'Quality Assurance',
    environment: 'Testing',
  },
};

export default function Login() {
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    setTimeout(() => {
      const user = Object.values(VALID_CREDENTIALS).find(
        (cred) => cred.username === username && cred.password === password
      );

      if (user) {
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem(
          'user',
          JSON.stringify({
            username: user.username,
            role: user.role,
            department: user.department,
            environment: user.environment,
          })
        );

        setLoading(false);
        navigate('/digitaltwin');
      } else {
        setError('Invalid username or password');
        setLoading(false);
      }
    }, 1000);
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0B1F3A 0%, #1e3a5f 100%)',
        padding: '16px',
        fontFamily:
          'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '420px',
          background: '#ffffff',
          borderRadius: '16px',
          padding: '32px 28px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          maxHeight: '95vh',
          overflow: 'auto',
        }}
      >
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '22px' }}>
          <div
            style={{
              width: '190px',
              height: '86px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 8px',
              background: 'transparent',
            }}
          >
            <img
              src={edfLogo}
              alt="EDF Purview Logo"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                display: 'block',
              }}
            />
          </div>

          <p
            style={{
              fontSize: '13px',
              color: '#64748b',
              margin: '2px 0 0 0',
            }}
          >
            Data Center Operations
          </p>
        </div>

        {/* Welcome Text */}
        <div style={{ marginBottom: '20px' }}>
          <h2
            style={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#0f172a',
              margin: 0,
            }}
          >
            Welcome Back
          </h2>

          <p
            style={{
              fontSize: '13px',
              color: '#64748b',
              margin: '4px 0 0 0',
            }}
          >
            Sign in to access your dashboard
          </p>
        </div>

        {/* Error Message */}
        {error && (
          <div
            style={{
              background: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: '8px',
              padding: '10px 14px',
              marginBottom: '16px',
              color: '#dc2626',
              fontSize: '13px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <span>⚠️</span>
            {error}
          </div>
        )}

        {/* Login Form */}
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '16px' }}>
            <label
              htmlFor="username"
              style={{
                display: 'block',
                fontSize: '13px',
                fontWeight: 600,
                color: '#0f172a',
                marginBottom: '6px',
              }}
            >
              Username
            </label>

            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
              style={{
                width: '100%',
                padding: '10px 14px',
                fontSize: '14px',
                border: '2px solid #e2e8f0',
                borderRadius: '8px',
                outline: 'none',
                transition: 'border-color 0.2s, box-shadow 0.2s',
                boxSizing: 'border-box',
                background: '#f8fafc',
                fontFamily: 'inherit',
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#3b82f6';
                e.target.style.background = '#ffffff';
                e.target.style.boxShadow =
                  '0 0 0 3px rgba(59, 130, 246, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.background = '#f8fafc';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label
              htmlFor="password"
              style={{
                display: 'block',
                fontSize: '13px',
                fontWeight: 600,
                color: '#0f172a',
                marginBottom: '6px',
              }}
            >
              Password
            </label>

            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              style={{
                width: '100%',
                padding: '10px 14px',
                fontSize: '14px',
                border: '2px solid #e2e8f0',
                borderRadius: '8px',
                outline: 'none',
                transition: 'border-color 0.2s, box-shadow 0.2s',
                boxSizing: 'border-box',
                background: '#f8fafc',
                fontFamily: 'inherit',
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#3b82f6';
                e.target.style.background = '#ffffff';
                e.target.style.boxShadow =
                  '0 0 0 3px rgba(59, 130, 246, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.background = '#f8fafc';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '15px',
              fontWeight: 600,
              color: '#ffffff',
              background: loading ? '#94a3b8' : '#1e40af',
              border: 'none',
              borderRadius: '8px',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              boxShadow: loading
                ? 'none'
                : '0 4px 12px rgba(30, 64, 175, 0.3)',
              fontFamily: 'inherit',
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.background = '#1e3a8a';
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow =
                  '0 6px 16px rgba(30, 64, 175, 0.4)';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.background = '#1e40af';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow =
                  '0 4px 12px rgba(30, 64, 175, 0.3)';
              }
            }}
          >
            {loading ? (
              <>
                <span
                  style={{
                    display: 'inline-block',
                    width: '18px',
                    height: '18px',
                    border: '2px solid #ffffff',
                    borderTop: '2px solid transparent',
                    borderRadius: '50%',
                    animation: 'spin 0.8s linear infinite',
                  }}
                />
                Signing in...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>

        {/* Spin Animation */}
        <style>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
}